module.exports = __webpack_public_path__ + "static/img/7.024a19f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/zh/7.png
// module id = dZ0i
// module chunks = 0